// extracted by mini-css-extract-plugin
module.exports = {"addButton":"AddButton_addButton__1HY7l","addIcon":"AddButton_addIcon__2HjSi"};